import React, { Component } from "react";
import { Card, CardBody, Col, Row, CardTitle, Alert,Container,Button,Table,Badge,CardFooter,Modal,Label } from "reactstrap";
import { AvForm, AvField,AvInput,AvGroup  } from 'availity-reactstrap-validation';
import {CustomPagination} from "../Common/CustomPagination";
import {DataTabeSearch} from '../Common/DataTabeSearch'
// Redux
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { createParkDeviceSettings,getParkDeviceSettingsList,editParkDeviceSettings,userList,getRateList} from '../../../store/parkDeviceSetings/actions';
import { rateTypeList,vehicleTypeList} from '../../../store/parkingRate/actions';
import { parkingSpaceNameList} from '../../../store/parkingSpaceName/actions';
import { parkingSlotList} from '../../../store/parkingSlot/actions';
import { parkList} from '../../../store/parkInfo/actions';


class ParkDeviceAuthorizationCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
                page: 1,
                per_page: 10,
                search: '',
                customchk: true,
                toggleSwitch: false,
                edittoggleSwitch: false,  
                modal_scroll: false,
                slot: {
                    
                }
            };
        // this.tog_scroll = this.tog_scroll.bind(this);
    }

    componentDidMount()
    {
            this.fetchParkdeviceList();      
            this.fetchVehicleTypeList();     
            this.fetchparkInfoList();     
            this.fetchparkingSlotList();  
            this.fetchUserList();  
    }

    fetchUserList = () => {
        userList().then((response) => {
            this.setState({
                userList : response.data.data, 
            });
        })
        .catch((err) => {
            console.log(err);
        })
    }

    fetchRateList = (park_info_id) => {
        getRateList(park_info_id).then((response) => { 
            this.setState({
                rateList : response.data.ParkRate, 
            });
        })
        .catch((err) => {
            console.log(err);
        })
    }

    fetchVehicleTypeList = () => {
        vehicleTypeList().then((response) => {
            this.setState({
                vehicleTypeList : response.data.vehicleType, 
            });
        })
        .catch((err) => {
            console.log(err);
        })
    }

    fetchparkInfoList = () => {
        parkList().then((response) => {
            this.setState({
                parkList :response.data.data, 
            });

        })
        .catch((err) => {
            console.log(err);
        })
    }

    fetchparkingSlotList = () => {
        
        parkingSlotList().then((response) => {

            this.setState({
                parkingSlotList :response.data.data, 
            });
        })
        .catch((err) => {
            console.log(err);
        })
    }

    fetchParkdeviceList = () => {
        let options = {
            page: this.state.page,
            per_page: this.state.per_page,
            search: this.state.search
        }
        getParkDeviceSettingsList(options).then((response) => {

            this.setState({
                ParkDeviceSettingsList :response.data, 
            });
        })
        .catch((err) => {
            console.log(err);
        })
    }

    //modal
    tog_scroll = (slot) => {
        this.setState(prevState => ({
          modal_scroll: !prevState.modal_scroll,
        }));
        this.state.slot = slot;
        this.removeBodyCss();

        this.fetchRateList(slot.f_park_info_id);
      }

      removeBodyCss() {
        document.body.classList.add("no_padding");
      }

      // handleValidSubmit
        handleValidSubmit(event, values) {          
            this.props.createParkDeviceSettings(values);
            this.form && this.form.reset();
            this.fetchParkdeviceList();     
        }

       
       handleEditSubmit(event, values) {  
            this.props.editParkDeviceSettings(values);
            this.setState(prevState => ({
                modal_scroll: !prevState.modal_scroll,
              }));

            this.fetchParkdeviceList(); 
       }

       autoSearchInputChange = (event) => { 
        event.preventDefault();
        const { target: { name, value } } = event;

        if(name == 'f_park_info_id') { 
            this.fetchRateList(value);
        }
        
      }

       handleInputChange = (e) => {
        this.setState({[e.target.name]: e.target.value},() => {
            this.fetchParkdeviceList();
        });
       }

       handlePageClick = (e, index) => {
            e.preventDefault()
            this.setState({
                page: index
            },() => {
                this.fetchParkdeviceList();
            });
        }

    render() {
        let vehicleTypeList = [];
        let rateLists = [];
        let parkList = [];
        let ParkDeviceSettingsList = [];
        let parkingSlotList = [];
        let userList = [];
        let paginator;
        if (this.state.hasOwnProperty('ParkDeviceSettingsList')) {
            ParkDeviceSettingsList = this.state.ParkDeviceSettingsList.data;
            paginator = {
                'currentPage':this.state.ParkDeviceSettingsList.current_page,
                'pagesCount':this.state.ParkDeviceSettingsList.last_page,
                'total':this.state.ParkDeviceSettingsList.total,
                'to':this.state.ParkDeviceSettingsList.to,
                'from':this.state.ParkDeviceSettingsList.from,
            }
        }

        if (this.state.hasOwnProperty('vehicleTypeList')) { vehicleTypeList = this.state.vehicleTypeList; }
        if (this.state.hasOwnProperty('rateList')) { rateLists = this.state.rateList; }
        if (this.state.hasOwnProperty('parkList')) { parkList = this.state.parkList; }
        if (this.state.hasOwnProperty('parkingSlotList')) { parkingSlotList = this.state.parkingSlotList; }
        if (this.state.hasOwnProperty('userList')) { userList = this.state.userList; }

        const {id,device_id,mobile,f_park_info_id,f_park_rate,priority,status,f_user_id,} = this.state.slot;

        const getBadge = (status) => {
            return status == 1 ? 'success' : 'secondary'
          }
          
          const getStatusValue = (status) => {
              return status == 1 ? 'Active' : 'In-active'
          }
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid={true}>

                        <Breadcrumbs title="Settings" breadcrumbItem="Park Device Settings" />
                        {this.props.error && this.props.error ? <Alert color="danger">{this.props.error}</Alert> : null}
                        {this.props.success && this.props.success ? <Alert color="success">{this.props.success}</Alert> : null}
                        <Row>
                        <Col lg="8" md="8">
                                <Card>
                                    <CardBody>
                                        <CardTitle>Park Device Settings List</CardTitle>
                                        <div className="table-responsive">
                                        <DataTabeSearch handleInputChange={this.handleInputChange}/>
                                            <Table className="table  mb-0">

                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>User</th>
                                                        <th>Device ID</th>
                                                        <th>Mobile No</th>
                                                        <th>Park Name</th>
                                                        <th>Rate</th>
                                                        <th>Priority</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {ParkDeviceSettingsList.map((device, index) =>
                                                    <tr key={device.id .toString()}>
                                                        <td scope="row">{index+1}</td>
                                                        <td>{device.user == null?device.f_user_id:device.user.name}</td>
                                                        <td>{device.device_id}</td>
                                                        <td>{device.mobile}</td>
                                                        <td>{device.park_info == null? device.f_park_info_id:device.park_info.park_name_en}</td>
                                                        <td>{device.park_rate == null? device.f_park_rate: device.park_rate.rate}</td>
                                                        <td>{device.priority}</td>
                                                        <td>{device.status == 1? 'Active':'Deactive'}</td>
                                                        <td><button type="button"
                                                               className="btn btn-sm btn-primary waves-effect waves-light"
                                                               onClick={() => { this.tog_scroll(device) }} 
                                                               data-toggle="modal"
                                                             >Edit</button>
                                                            </td>
                                                       </tr>
                                                )}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </CardBody>
                                    {paginator &&
                                     <CardFooter className="p-6">
                                          <CustomPagination paginator={paginator} handlePageClick={this.handlePageClick} />
                                      </CardFooter>
                                      }
                                </Card>
                                <Modal
                                 isOpen={this.state.modal_scroll}
                                   toggle={this.tog_scroll}
                                   scrollable={true}
                                   >
                                   <div className="modal-header">
                                       {/* <h5 className="modal-title mt-0">{device_name}</h5> */}
                                       <button
                                       type="button"
                                       onClick={() =>
                                           this.setState({ modal_scroll: false })
                                       }
                                       className="close"
                                       data-dismiss="modal"
                                       aria-label="Close"
                                       >
                                       <span aria-hidden="true">&times;</span>
                                       </button>
                                   </div>
                                   <div className="modal-body">
                                   <AvForm className="form-horizontal" onValidSubmit={(e,v) => { this.handleEditSubmit(e,v) }}>
                                       {this.props.msg && this.props.msg ? (
                                           <Alert color="success">
                                              Park Device Updated Successfully!
                                           </Alert>
                                           ) : null}
                                                
                                                <div className="form-group col-md-12">
                                                    <AvField type="select"className="custom-select" label="User" name="f_user_id" id="f_user_id" value={f_user_id} required>
                                                            <option value="">Select</option>
                                                            {userList.map((user, index) =>
                                                                <option value={user.id}>{user.name}</option>
                                                            )}
                                                    </AvField>
                                                    <AvField name="id" id="id" value={id}  type="hidden"  />
                                                </div>

                                                 <div className="col-md-12">
                                                     <AvField className="form-control" type="text" label="Device ID"  id="device_id" name="device_id" value={device_id}  required/>
                                                 </div>

                                                 <div className="col-md-12">
                                                     <AvField className="form-control" label="Mobile No "  type="number" name="mobile" id="mobile" value={mobile} required/>
                                                 </div>
                                            
                                             
                                                 <div className="form-group col-md-12">
                                                    <AvField type="select"className="custom-select" label="Park" name="f_park_info_id" id="f_park_info_id" value={f_park_info_id} onChange={(e) => this.autoSearchInputChange(e)} required>
                                                            <option value="">Select</option>
                                                            {parkList.map((space, index) =>
                                                                <option value={space.id}>{space.park_name_en}</option>
                                                            )}
                                                    </AvField>
                                                </div>

                                                <div className="form-group col-md-12">
                                                    <AvField type="select"className="custom-select" label="Rate" name="f_park_rate_id" id="f_park_rate_id" value={f_park_rate}  required>
                                                            <option value="">Select Rate</option>
                                                            {rateLists.map((rtype, index) =>
                                                                <option value={rtype.id}>{rtype.rate}</option>
                                                            )}
                                                    </AvField>
                                                </div>
                                                

                                                <div className="form-group col-md-12 " >
                                                        <AvField type="select" className="custom-select" label="Status" name="status" id="Status" value={status} required>
                                                            <option value="">Select Status</option>
                                                            <option value="1">active</option>
                                                            <option value="2">Deactive</option>
                                                        </AvField>
                                                </div>

                                                <div className="col-md-12">
                                                     <AvField className="form-control" label="Priority "  type="number" name="priority" id="priority" value={priority} required/>
                                                 </div>


                                                 
                                           <div className="text-center mt-4">
                                                <button type="button" className="btn btn-light mr-2" onClick={this.tog_scroll}>Close</button>
                                                <button type="submit" className="btn btn-success save-event">Save</button>
                                           </div>
                                   </AvForm>
                                   </div>
                               </Modal>
                            </Col>
                            <Col lg="4" md="4">
                                <Card>
                                    <CardBody>
                                        <CardTitle>Create Park Device Authorization</CardTitle>
                                        
                                        <AvForm className="form-horizontal" onValidSubmit={(e,v) => { this.handleValidSubmit(e,v) }} ref={c => (this.form = c)}>
                                                <div className="form-group col-md-12">
                                                    <AvField type="select"className="custom-select" label="User" name="f_user_id" id="f_user_id" required>
                                                            <option defaultValue>Select</option>
                                                            {userList.map((user, index) =>
                                                                <option value={user.id}>{user.name}</option>
                                                            )}
                                                    </AvField>
                                                </div>

                                                 <div className="col-md-12">
                                                     <AvField className="form-control" type="text" label="Device ID"  id="device_id" name="device_id" required/>
                                                 </div>

                                                 <div className="col-md-12">
                                                     <AvField className="form-control" label="Mobile No "  type="number" name="mobile" id="mobile" required/>
                                                 </div>
                                            
                                             
                                                 <div className="form-group col-md-12">
                                                    <AvField type="select"className="custom-select" label="Park" name="f_park_info_id" id="f_park_info_id" onChange={(e) => this.autoSearchInputChange(e)} required>
                                                            <option defaultValue>Select</option>
                                                            {parkList.map((space, index) =>
                                                                <option value={space.id}>{space.park_name_en}</option>
                                                            )}
                                                    </AvField>
                                                </div>

                                                <div className="form-group col-md-12">
                                                    <AvField type="select"className="custom-select" label="Rate" name="f_park_rate_id" id="f_park_rate_id" required>
                                                            <option defaultValue>Select</option>
                                                            {rateLists.map((rtype, index) =>
                                                                <option value={rtype.id}>{rtype.rate}</option>
                                                            )}
                                                    </AvField>
                                                </div>
                                                

                                                <div className="form-group col-md-12 " >
                                                        <AvField type="select" className="custom-select" label="Status" name="status" id="Status" required>
                                                            <option defaultValue>Select Status</option>
                                                            <option value="1">active</option>
                                                            <option value="2">Deactive</option>
                                                        </AvField>
                                                </div>

                                                <div className="col-md-12">
                                                     <AvField className="form-control" label="Priority "  type="number" name="priority" id="priority" required/>
                                                 </div>
                                                

                                             <div className=" mt-4">
                                                 <Button type="submit" color="success">Submit</Button>
                                             </div>
                                         </AvForm>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { msg,error,success } = state.DeviceSetings;
    return { msg,error,success };
}

export default withRouter(connect(mapStatetoProps, { createParkDeviceSettings,editParkDeviceSettings })(ParkDeviceAuthorizationCreate));
